module.exports = __webpack_public_path__ + "static/media/b.f2be88f7.jpg";